import * as UserTypes from './user.types';
import {
  IInitialUserState,
  TUpdateLanguageProps,
  TUpdateUserPick,
} from 'interfaces/user.interface';
import moment from 'moment';
import {
  IloginDbUserAPIResponseData,
  IupdateUserImageAPIResponseData,
} from 'api/endpoints/user/user.response.interface';
import { superAdminRole } from 'utils/constants';
import { IgetClientsAPIResponseDataItemUserItem } from 'api/endpoints/superAdmin/superAdmin.response.interface';

export type TuserDispatchReducer =
  | {
      type: typeof UserTypes.LOGIN_USER;
      payload: IloginDbUserAPIResponseData;
    }
  | {
      type: typeof UserTypes.LOGIN_USER_SUPER_ADMIN;
      payload: IgetClientsAPIResponseDataItemUserItem;
    }
  | {
      type: typeof UserTypes.UPDATE_USER;
      payload: TUpdateUserPick;
    }
  | {
      type: typeof UserTypes.UPDATE_USER_AVATAR;
      payload: IupdateUserImageAPIResponseData;
    }
  | {
      type: typeof UserTypes.VERIFY_EMAIL;
      payload: boolean;
    }
  | {
      type: typeof UserTypes.UPDATE_LANGUAGE;
      payload: TUpdateLanguageProps;
    }
  | {
      type: typeof UserTypes.SET_IS_LOADING;
      payload: boolean;
    };

export default function userReducer(
  state: IInitialUserState,
  action: TuserDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case UserTypes.LOGIN_USER: {
      const loginUser: IInitialUserState = {
        ...state,
        dbUser: {
          ...payload,
          profile_image: payload?.profile_image
            ? `${payload?.profile_image}?ts=${moment().unix()}`
            : '',
        },
      };
      return loginUser;
    }

    case UserTypes.LOGIN_USER_SUPER_ADMIN: {
      const loginCompanyUserSuperAdmin: IInitialUserState = {
        ...state,
        dbUser: {
          ...payload.user,
          email: payload.user.username,
          role: superAdminRole,
          telephone_prefix: payload.user.tel_prefix,
          telephone_sufix: payload.user.tel_sufix,
          profile_image: payload.user.profile_image
            ? `${payload.user.profile_image}?ts=${moment().unix()}`
            : '',
          user_clients: [],
        },
      };
      return loginCompanyUserSuperAdmin;
    }

    case UserTypes.UPDATE_USER: {
      const updateUser: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          name: payload.name,
          surname: payload.surname,
          telephone_prefix: payload.tel_prefix,
          telephone_sufix: payload.tel_sufix,
          sector: payload.sector,
        },
      };
      return updateUser;
    }

    case UserTypes.UPDATE_USER_AVATAR: {
      const updateUserAvatar: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          profile_image: `${payload.url}?ts=${moment().unix()}`,
        },
      };
      return updateUserAvatar;
    }

    case UserTypes.VERIFY_EMAIL: {
      const verifyEmail: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          enabled: payload,
        },
      };
      return verifyEmail;
    }

    case UserTypes.UPDATE_LANGUAGE: {
      const updateLanguage: IInitialUserState = {
        ...state,
        dbUser: {
          ...(state.dbUser as IloginDbUserAPIResponseData),
          i18n_lang_id: payload.id,
        },
      };
      return updateLanguage;
    }

    case UserTypes.SET_IS_LOADING: {
      const setIsLoading: IInitialUserState = {
        ...state,
        isLoading: payload,
      };
      return setIsLoading;
    }

    default:
      return state;
  }
}
